<script>
	export let href = "/";
	export let label;
	export let click = null;
	export let width = "100%";
	export let disabled = false;

	function doClick(ev) {
		if (disabled || click) {
			ev.preventDefault();
			ev.cancelBubble = true;
		}

		if (click) {
			click(ev);
		}
	}
</script>

<a
	{href}
	class="btn"
	class:disabled
	target="_blank"
	on:click={doClick}
	style="width:{width}">
	{label}
</a>

<style>
	.btn {
		margin-top: 2rem;
		color: rgba(255, 255, 255, 0.9);
		background-color: #7e57c2;
		border-color: #7e57c2;

		display: inline-block;
		vertical-align: top;
		outline: none;
		text-align: center;
		border: 1px solid;
		border-radius: 0.2rem;
		cursor: pointer;

		font-size: 1.8rem;
		line-height: 2.4rem;
		font-weight: 500;
		padding: 1.2rem 3.4rem;
		text-transform: capitalize;
		transition: all 0.5s ease;
		position: relative;
		overflow: hidden;

		width: 100%;
	}
	.btn:hover {
		color: rgba(255, 255, 255, 0.9);
		background-color: #6b41b4;
		border-color: #6b41b4;
	}
	.btn:after {
		content: "";
		display: block;
		height: 2rem;
		position: absolute;
		left: -95%;
		bottom: 15%;
		background-color: #fff;
		transform: rotateZ(45deg);
	}
	.btn:hover:after {
		transition: all 0.3s ease;
		left: 100%;
	}
	.disabled,
	.disabled:hover {
		background-color: silver;
		border: 1px solid transparent;
	}
	.disabled:hover:after {
		transition: none;
		left: -95%;
	}
	@media screen and (max-width: 890px) {
		.btn {
			font-size: 16px;
			max-width: max-content;
		}
	}
</style>
